import React, { useReducer } from "react"
import PropTypes from "prop-types"
import TemplatesManagerContext from "./TemplatesManagerContext"
import templatesManagerReducer, {
  initialState,
} from "./templatesManagerReducer"

const TemplatesManagerState = ({ children }) => {
  const [state, dispatch] = useReducer(templatesManagerReducer, initialState)

  return (
    <TemplatesManagerContext.Provider value={{ state, dispatch }}>
      {children}
    </TemplatesManagerContext.Provider>
  )
}

TemplatesManagerState.propTypes = {
  children: PropTypes.node,
}

export default TemplatesManagerState
